<template>
  <closeable-dialog v-model="keyboardStore.settingsOpen">
    <v-card class="pa-4">
      <div class="text-h4 pb-2">{{ t('controlsModal.viewControlsTitle') }}</div>
      <v-table>
        <tbody>
          <tr>
            <td>{{ t('controlsModal.scrollSlices') }}</td>
            <td>{{ t('controlsModal.scrollSlicesAction') }}</td>
          </tr>
          <tr>
            <td>{{ t('controlsModal.zoom') }}</td>
            <td>{{ t('controlsModal.zoomAction') }}</td>
          </tr>
          <tr>
            <td>{{ t('controlsModal.pan') }}</td>
            <td>{{ t('controlsModal.panAction') }}</td>
          </tr>
        </tbody>
      </v-table>

      <div class="text-h4 pb-2">{{ t('controlsModal.keyboardShortcutsTitle') }}</div>
      <v-table>
        <tbody>
          <tr v-for="[action, key] in bindings" :key="action">
            <td>{{ action }}</td>
            <td class="keybinding">{{ key }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </closeable-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { actionToKey } from '@/src/composables/useKeyboardShortcuts';
import { ACTIONS } from '@/src/constants';
import { useKeyboardShortcutsStore } from '@/src/store/keyboard-shortcuts';
import CloseableDialog from './CloseableDialog.vue';
import { getEntries } from '../utils';

const { t } = useI18n();

const keyboardStore = useKeyboardShortcutsStore();

const bindings = computed(() =>
  getEntries(actionToKey.value).map(([action, key]) => [
    ACTIONS[action].readable,
    key,
  ])
);
</script>

<style scoped>
.keybinding {
  font-family: monospace;
}
</style>
